import { authFetch } from '~/services/fetch'

interface StationsActionsParams {
  readonly origin?: 'station' | 'stations' | null
  readonly station_id?: number | null
  readonly stations_id?: number | null
  readonly action?: string | null
  readonly start_date: string
  readonly finish_date: string
  readonly page?: number
  readonly limit?: number
  readonly orders?: readonly { readonly field: string; readonly sort: string }[]
}

export async function getStationsActionsLogs(params: StationsActionsParams) {
  const { orders, ...otherParams } = params
  const response = await authFetch({
    url: '/logs/station-actions',
    method: 'POST',
    data: {
      ...otherParams,
      orders: orders || [{ field: 'created_at', sort: 'desc' }],
    },
  })

  return response.data
}

export const getStationsLogDetails = async (id: number): Promise<any> => {
  try {
    const response = await authFetch({
      url: `/logs/details/${id}`,
      method: 'GET',
    })
    if (!response.status || response.status !== 200) {
      throw new Error('Erro ao buscar detalhes do log')
    }
    return response.data
  } catch (error) {
    console.error('Erro na requisição:', error)
    throw error
  }
}
